// extracted by css-extract-rspack-plugin
export default {"toolCalls":"aR_Qf","toolCallStarted":"aPVf9","rotate-background":"iJHM4"};